export type Currency = {
  uuid: string
  name: string
  symbol: string
  symbolNative: string
  code: string
  countryId: string
}

export type Curriculum = {
  uuid: string
  name: string
  isDefault: true | null
}

export type Language = {
  uuid: string
  name: string
  localeCode: string
  nativeName: string
}

export type Subject = {
  uuid: string
  name: string
  addedById: string | null
  isApproved: boolean
}

export type Country = {
  isoCode: string
  isoCode3: string
  name: string
  uuid: string
}

export type State = {
  uuid: string
  name: string
  isoCode: string
  countryId: string
}

export type QualificationField = {
  id: number
  uuid: string
  name: string
  addedById: string | null
  isApproved: boolean
}

export enum Gender {
  MALE = "male",
  FEMALE = "female",
  PREFER_NOT_TO_SAY = "prefer_not_to_say",
}
